import { render, staticRenderFns } from "./SUploader.vue?vue&type=template&id=1557666a&"
import script from "./SUploader.vue?vue&type=script&lang=js&"
export * from "./SUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports